import React from "react";
import "./styles.scss";

interface Props {
  children: React.ReactNode;
}

const H3: React.FC<Props> = ({
  children,
  ...rest
}) => {
  return (
    <div className="h3">{children}</div>
  );
};

export default H3;

